import Accordioncommon from "@frameworks/web/components/generic/Accordion/accordion";
import React from "react";
import { Col, Row } from "react-bootstrap";
var UnderStanding = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "m-0" },
            React.createElement(Col, { lg: 12, className: "p-0" },
                React.createElement(Accordioncommon, { AccordionArray: props.data, parentClass: "tocaccordian", defaultActiveKey: props.activeKey })))));
};
export default UnderStanding;
